import React from 'react'

import './styles.scss'

function TickIcon({ isCheckIconVisible }) {
    return (
        <div className="tick-container">
            {isCheckIconVisible && <svg
                className={`tick-icon${isCheckIconVisible ? '--show' : '--hide'}`}
                width="20"
                height="20"
                viewBox="0 0 104 79"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M36.3 77.45L0.649993 41.99C0.444393 41.7856 0.281236 41.5425 0.169901 41.2748C0.0585662 41.0071 0.00125122 40.72 0.00125122 40.43C0.00125122 40.1401 0.0585662 39.853 0.169901 39.5853C0.281236 39.3175 0.444393 39.0745 0.649993 38.87L9.64999 29.86C10.51 29 11.9 29 12.76 29.86L36.23 53.19C37.09 54.05 38.49 54.04 39.35 53.18L91.21 0.820015C92.07 -0.0499847 93.47 -0.0499849 94.34 0.810015L103.35 9.82001C104.21 10.68 104.21 12.07 103.36 12.93L46.86 69.94L46.87 69.95L39.42 77.44C38.56 78.3 37.16 78.3 36.3 77.45Z"
                    fill={'var(--color-exercise)'}
                />
            </svg>}
        </div>
    )
}

export default TickIcon
